import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=4b8a97ea&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b8a97ea')) {
      api.createRecord('4b8a97ea', component.options)
    } else {
      api.reload('4b8a97ea', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=4b8a97ea&", function () {
      api.rerender('4b8a97ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BoBMEha5c6wo/JS/comp/DateRangeExt.vue"
export default component.exports